class Tix02Switch extends HTMLElement {
    constructor() {
        super();
        this._internals = this.attachInternals();
        this.addEventListener('click', this._onClick.bind(this));
        this._internals.role = 'checkbox';
        this._internals.ariaChecked = 'false';
        const shadow = this.attachShadow({ mode: 'open' });
        const wrapper = this.getMarkup();
        const styles = this.getStyles();
        shadow.appendChild(styles);
        shadow.appendChild(wrapper);
    }
    get form() {
        return this._internals.form;
    }
    get name() {
        return this.getAttribute('name');
    }
    get type() {
        return this.localName;
    }
    get value() {
        return this.getAttribute('value');
    }
    get checked() {
        return this.hasAttribute('checked');
    }
    set checked(flag) {
        this.toggleAttribute('checked', Boolean(flag));
    }
    attributeChangedCallback(name, oldValue, newValue) {
        this._internals.setFormValue(this.checked ? 'on' : null);
        this._internals.ariaChecked = this.checked ? 'true' : 'false';
    }
    _onClick() {
        this.checked = !this.checked;
    }
    getMarkup() {
        const innerEl = document.createElement('span');
        innerEl.classList.add('-tix02-switch--inner');
        const buttonEl = document.createElement('span');
        buttonEl.classList.add('-tix02-switch--button');
        innerEl.appendChild(buttonEl);
        const trackEl = document.createElement('span');
        trackEl.classList.add('-tix02-switch--track');
        innerEl.appendChild(trackEl);
        const switchEl = document.createElement('div');
        switchEl.classList.add('-tix02-switch');
        switchEl.appendChild(innerEl);
        return switchEl;
    }
    getStyles() {
        const style = document.createElement('style');
        style.textContent = `
	  :host {
		display:inline-block;
		width:48px;
		height:24px;
		aspect-ratio:2 / 1;
		accent-color: auto;
	  }

	  :host([disabled]) {
		pointer-events:none;
		cursor:defaut;
		opacity:.5;
	  }
	  
	  :host * {
		margin:0;
		border:0;
		padding:0;
		box-sizing:border-box;
		
	  }
	  
	  .-tix02-switch,
	  .-tix02-switch--inner,
	  .-tix02-switch--button:before,
	  .-tix02-switch--track {
		width:100%;
		height:100%;
	  }

	  .-tix02-switch {
		display:block;
		cursor:pointer;
	  }

	  .-tix02-switch--inner,
	  .-tix02-switch--track {
		display:block;
	  }

	  .-tix02-switch--inner {
		position:relative;
		pointer-events:none;
	  }

	  .ts--cbx {
		opacity: 0;
		width: 0;
		height: 0;
		pointer-events:none;
	  }

	  .ts--cbx:focus + .-tix02-switch--track {
		box-shadow: 0 0 1px currentColor;
	  }

	  .-tix02-switch--button,
	  .-tix02-switch--track {
		position:absolute;
		top:0;
		left:0;
	  }

	  .-tix02-switch--track {
		height:50%;
		background-color: currentcolor;
		transition:background-color .25s;
		z-index:0;
		translate: 0 50%;
		border-radius: 100px;
		opacity:.5;
	  }

	  .-tix02-switch--button {
		z-index:1;
		height:100%;
		aspect-ratio: 1 / 1;
		background-color:currentcolor;
		transition:all .25s ease;
		border-radius: 100%;
	  }

	  :host([checked]) .-tix02-switch--button {
		left:100%;
		background-color: currentcolor;
		translate:-100%;
		box-shadow:3px 3px 12px rgba(0, 0, 0, .08);
	  }
	`;
        return style;
    }
}
Tix02Switch.formAssociated = true;
Tix02Switch.observedAttributes = ['checked'];
customElements.define('uix-switch', Tix02Switch);
export default Tix02Switch;
